import { useState, useEffect } from 'react';

/**
 * Custom hook to track a media query and re-render when it matches/unmatches.
 * @param {string} query - The media query to track (e.g., '(max-width: 767px)')
 * @returns {boolean} - Whether the media query matches the current viewport
 */
export function useMediaQuery(query) {
  const [matches, setMatches] = useState(() => 
    typeof window !== 'undefined' ? window.matchMedia(query).matches : false
  );

  useEffect(() => {
    if (typeof window === 'undefined') return;
    
    const media = window.matchMedia(query);
    const listener = () => setMatches(media.matches);
    
    // Initial check
    if (media.matches !== matches) {
      setMatches(media.matches);
    }
    
    media.addEventListener('change', listener);
    return () => media.removeEventListener('change', listener);
  }, [query, matches]);

  return matches;
}
